import { LoginForm } from '@/components/auth/LoginForm'
import { useAuth } from '@/contexts/AuthContext'
import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const LoginPage: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const from = location.state?.from?.pathname || '/dashboard'

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true })
    }
  }, [isAuthenticated, navigate, from])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center flex flex-col items-center">
          <Link to="/" className="inline-block mb-4">
            <img src="/logo.svg" alt="GTP Logo" className="h-12 w-auto object-contain" />
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">ASG Admin</h1>
          <p className="mt-2 text-sm text-gray-600">Water Pump E-commerce Platform</p>
        </div>

        <LoginForm />

        <div className="text-center">
          <Link to="/" className="text-sm text-primary-600 underline-offset-4 hover:underline">
            ← Back to website
          </Link>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
